<template>
    <b-container fluid class="animated fadeIn">
        <h1>Cartas Para Assinar e Emissão em Lote</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div>
                        <b-card class="primary-semi p-2">
                            <b-row>
                                <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                    <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
                                        <the-mask id="cpfCnpj" class="form-control" v-model="filtro.cpfCnpj"
                                            :mask="['##.###.###/####-##', '###.###.###-##']" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                                        <multiselect v-model="filtro.credito" :show-labels="false" :options="dados.creditos"
                                            :multiple="true" :close-on-select="false" :clear-on-select="false"
                                            :preserve-search="true" placeholder="Selecione" :showNoResults="false"
                                            label="nome" track-by="id">
                                            <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{
                                                    values.length }} selecionado(s)</span>
                                            </template>
                                        </multiselect>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <b-button variant="primary" class="fonte-branca" @click="filtrar">
                                            <i class="fa fa-search"></i> Pesquisar
                                        </b-button>
                                        <file-upload ref="upload" :multiple="false" :maximum="1" extensions="csv"
                                            v-model="arquivo" @input-file="anexarCsv">
                                            <b-button variant="primary" class="fonte-branca ml-1">
                                                <i class="fa fa-list"></i> Incluir Cartas em Lote
                                            </b-button>
                                        </file-upload>
                                        <b-button variant="primary" class="ml-2" @click="exibirPdf"
                                            :disabled="selecteds.length == 0">
                                            <i class="fa fa-download"></i> Exibir
                                        </b-button>
                                        <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                            <i class="fa fa-eraser"></i> Limpar
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Total de Cartas Exibidas - <strong>{{ configTable.rows
                                            }}</strong> / Total de Cartas Selecionadas - <strong>{{ selecteds.length
}}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <div>
                                                <b-pagination v-model="configTable.currentPage"
                                                    :per-page="configTable.perPage" :total-rows="configTable.rows" size="sm"
                                                    class="pl-3" style="float:right" v-if="configTable.perPage != 'Todos'">
                                                </b-pagination>
                                                <b-form-select v-model="configTable.perPage"
                                                    :options="[20, 50, 200, 500, 1000, 'Todos']" size="sm"
                                                    class="mb-3 col-2" style="float:right"></b-form-select>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <CompTabelaCartasAssinatura :resultado="resultado" :fields="fields"
                                        :configTable="configTable" :selecteds="selecteds" @sortingChanged="consultarCartas"
                                        @consultarCartas="consultarCartas" />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <div>
                                                <b-pagination v-model="configTable.currentPage"
                                                    :per-page="configTable.perPage" :total-rows="configTable.rows" size="sm"
                                                    class="pl-3" style="float:right" v-if="configTable.perPage != 'Todos'">
                                                </b-pagination>
                                                <b-form-select v-model="configTable.perPage"
                                                    :options="[20, 50, 200, 500, 1000, 'Todos']" size="sm"
                                                    class="mb-3 col-2" style="float:right"></b-form-select>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <div class="d-flex justify-content-between mb-3">
                            <div>
                                <b-button class="mx-1" variant="primary" :disabled="!selecteds.length"
                                    @click.prevent="$refs['modalAssinarCarta'].show()"> Assinar</b-button>
                                    <b-button class="mx-1" variant="primary" :disabled="!resultado.length"
                                    @click="$refs['modalAssinarTodos'].show()"> Assinar Todos</b-button>
                                <b-button class="mx-1" variant="secondary" @click="voltar"><i class="fa fa-reply"></i>
                                    Voltar</b-button>
                            </div>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
            <b-modal ref="modalAssinarCarta" size="lg" title="Assinar Carta(s)" cancel-title="Fechar">
                                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Deseja assinar a(s) carta(s) selecionada(s)?</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{}">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="assinarCarta('unica')">
                            Confirmar
                        </b-button>
                        <b-button variant="secondary" class="fonte-branca ml-1" @click="$refs['modalAssinarCarta'].hide()">
                            Cancelar
                        </b-button>
                    </div>
                </template>
                <!-- <Certificado :param="parametrosAssinatura" @finalizarAssinatura="processarArquivoAssinado($event)"
                    @erroAssinatura="processarErroAssinatura($event)" /> -->
            </b-modal>
            <b-modal ref="modalAssinarTodos" size="lg" title="Assinar todas as cartas"
                cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Deseja assinar todas as cartas?</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{}">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="assinarCarta('lote')">
                            Confirmar
                        </b-button>
                        <b-button variant="secondary" class="fonte-branca ml-1" @click="$refs['modalAssinarTodos'].hide()">
                            Cancelar
                        </b-button>
                    </div>
                </template>
            </b-modal>
            <b-modal ref="modalUpload" size="lg" title="Confirmar Importação de Cartas para Assinatura em Lote"
                cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Arquivo Selecionado:</p>
                    </b-col>
                    <b-col xs="12" md="12" class="mx-auto">
                        <p>{{ arquivo.length > 0 ? arquivo[0].name : '' }}</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{}">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="uploadFile">
                            Confirmar
                        </b-button>
                        <b-button variant="secondary" class="fonte-branca ml-1" @click="hideModal('modalUpload')">
                            Cancelar
                        </b-button>
                    </div>
                </template>
            </b-modal>
            <b-modal ref="modalErrorUpload" size="lg" title="Erro de Importação de Cartas para Assinatura em Lote"
                cancel-title="Fechar">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Erro ao importar arquivo:</p>
                    </b-col>
                    <b-col xs="12" md="12" class="mx-auto">
                        <p v-for="erro in errosUpload">{{ erro }}</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{}">
                    <div class="d-flex justify-content-between">
                        <b-button variant="primary" class="fonte-branca ml-1" @click="hideModal('modalErrorUpload')">
                            Fechar
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompTabelaCartasAssinatura from './components/CompTabelaCartasAssinatura'
import Certificado from "assinador-bry";
import apiCentralSeguranca from '@/api/centralseguranca';

export default {
    name: 'ConsultarCartasParaAssinatura',
    components: {
        CompTabelaCartasAssinatura,
        Certificado
    },
    data() {
        return {
            filtro: {
                cpfCnpj: null,
                credito: null
            },
            dados: {
                creditos: [],
                colunas: [' Número Dívida', 'Data Carta', 'Tipo de Carta', 'Motivo', 'Tipo Crédito', 'Origem', 'Tabelionato', 'Prot. CRA', 'Usuário', 'Devedor']
            },
            parametrosAssinatura: {
                config: {
                    padraoAssinatura: "1",
                    tipoAssinatura: "Attached",
                    incluiCadeia: true,
                },
                filters: {
                    CPFS: []
                },
                ambiente: process.env.VUE_APP_BRY_AMBIENTE,
                arquivo: this.listaPdfsRetorno,
                token: JSON.parse(this.$store.getters.getUser).token.access_token,
                consumerId: 'PGEPROAJU',
                realizarDownloadArquivoAssinado: false
            },
            configTable: {
                perPage: 20,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false
            },
            showColunms: [],
            selecteds: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            resultado: [],
            listaPdfsRetorno: [],
            arquivo: [],
            errosUpload: []
        }
    },
    watch: {
        perPage() {
            this.configTable.checkedAll = false
            this.selecteds = []
            this.configTable.currentPage = 1
            this.consultarCartas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        }
    },
    methods: {
        async assinarCarta (tipo) {
            let cartas = [];
            if (tipo === 'unica') {
                cartas = this.selecteds
            }
            else if (tipo === 'lote') {
                let oldPage = this.perPage;
                this.perPage = 'Todos'
                this.configTable.perPage = 'Todos';
                await this.consultarCartas()
                cartas = this.resultado
                this.perPage = oldPage;
                this.configTable.perPage = oldPage;
                await this.consultarCartas()
            }
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token
            await axios.post(`${urlApi}/v1/assinarCartasLote/assinarCarta`, cartas, 
            { headers: 
                {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then (response => {
                if (response.status === 200) {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Cartas(s) assinadas(s) com sucesso!'] });
                    this.$refs['modalAssinarTodos'].hide()
                    this.$refs['modalAssinarCarta'].hide()
                    this.selecteds = [];
                    this.consultarCartas()
                }
            })
            .catch ((error) => {
                console.log (error)
                this.$store.commit("setMessages", { message: 'Erro!', errors: ['Erro ao assinar todas as cartas.'] });
                this.$refs['modalAssinarTodos'].hide()
                this.$refs['modalAssinarCarta'].hide()
            })
            cartas = []
        },
        /**
         * Baixa o pdf do item selecionado
         */
        async exibirPdf() {
            if (this.selecteds.length != 0) {
                const urlApi = process.env.VUE_APP_ROOT_API
                const token = JSON.parse(this.$store.getters.getUser).token.access_token
                this.selecteds.forEach(registro => {
                    axios.post(`${urlApi}/v1/emitirCartasLote/obterPdfCartaExibir`, [registro], {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        },
                        responseType: 'arraybuffer'
                    })
                        .then(function (response) {
                            if (!response.data) {
                                this.$store.commit("setMessages", { message: 'Erro!', errors: ['PDF da carta não encontrado no servidor.'] });
                                return;
                            }
                            let blob = new Blob([response.data], { type: 'application/pdf' })
                            let link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = 'pdf-carta.pdf'
                            link.click()
                        }).finally(() => {
                            this.loadCSV = false
                        })
                });
            } else {
                this.$store.commit("setMessages", { message: 'Erro!', errors: ['Ao menos um registro deverá ser selecionado para exibição das cartas.'] });
            }
        },

        /**
         * Efetua o download do pdf a partir do response
         */
        downloadPdf(response) {
            if (!response.data) {
                this.$store.commit("setMessages", { message: 'Erro!', errors: ['PDF da carta não encontrado no servidor.'] });
                return;
            }
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            link.download = 'pdf-carta.pdf'
            document.body.appendChild(link);
            link.click()
            document.body.removeChild(link);
        },

        processarErroAssinatura(erro) {
            alert(erro)
        },
        processarArquivoAssinado(arquivosAssinadosB64) {
            //enviar arquivo servidor, realizar download.

            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/assinarCartasLote/finalizarAssinatura`, arquivosAssinadosB64, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(() => {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Cartas(s) assinadas(s) com sucesso!'] });
                    this.selecteds = []
                })
                .catch((error) => {
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro de comunicação ocorreu com um sistema externo, tente novamente mais tarde.'] });
                    this.selecteds = []
                })
                .finally(() => {
                    this.loadingExit()
                    this.consultarCartas()
                })

        },
        /**
        * Abre a modal BRY
        */
       async obterCartasAssinarTodos () {
            let oldPage = this.perPage;
            this.perPage = 'Todos'
            this.configTable.perPage = 'Todos';
            await this.consultarCartas()
            this.perPage = oldPage;
            this.configTable.perPage = oldPage;
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token
            await axios.post(`${urlApi}/v1/assinarCartasLote/obterPdfsCartas`, this.resultado, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(response => {
                    this.listaPdfsRetorno = response.data
                    this.$refs['modalAssinarTodos'].show();
                })
        },
        hide() {
            this.$refs['modalAssinarTodos'].hide();
       },
        show() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).token.access_token
            axios.post(`${urlApi}/v1/assinarCartasLote/obterPdfsCartas`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(response => {
                    this.listaPdfsRetorno = response.data
                    this.parametrosAssinatura.arquivo = this.listaPdfsRetorno
                    this.$refs['modalBry'].show();
                }).finally(() => {
                    this.loadingExit()
                })
        },
        hide() {
            this.$refs['modalBry'].hide();
        },

        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                cpfCnpj: null,
                credito: null
            }
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.selecteds = []
            this.consultarCartas()
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if (i == 0 || i == 2 || i == 3 || i == 4 || i == 6 || i == 7)
                return 'text-center justify-content-center'
            if (i == 6)
                return 'text-left justify-content-center'
            return 'justify-content-center'
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/dashboard');
        },

        /**
         * Consultar divídas
         */
        async consultarCartas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = {
                cpfCnpj: this.filtro.cpfCnpj,
                tipoCredito: this.filtro.credito
            }

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if (this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            await axios.post(`${urlApi}/v1/assinarCartasLote/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    if (response.data.message) {
                        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: [response.data.message] });
                    } else {
                        this.resultado = response.data.resultado
                        if (this.configTable.perPage !== 'Todos') {
                            this.configTable.rows = response.data.rows
                        }

                        this.resultado.forEach(result => {
                            result.checked = false
                            this.selecteds.forEach(selected => {
                                if (result.codCarta == selected.codCarta) {
                                    result.checked = true
                                }
                            })
                        })
                    }
                }).finally(() => {
                    this.loadingExit()
                })
        },

        uploadFile() {
            var arquivosConvertidos = [];
            var file = this.arquivo[0].file;
            var reader = new FileReader();
            reader.onload = function () {
                var arquivoFormatado = {
                    nomeArquivo: file.name,
                    base64: reader.result
                };

                arquivosConvertidos.push(arquivoFormatado);
            };
            reader.readAsDataURL(file);

            reader.onloadend = () => this.executeUpload(arquivosConvertidos);
        },

        executeUpload(arquivosConvertidos) {
            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).token.access_token;

            axios.post(`${urlApi}/v1/assinarCartasLote/incluirCartasLote`, arquivosConvertidos[0], {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then(response => {
                if (response.data != null && response.data.listaMensagensRetorno.length > 0) {
                    this.errosUpload = response.data.listaMensagensRetorno;
                    this.showModal('modalErrorUpload');
                } else {
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Operação realizada com sucesso!!!'] });
                    window.scrollTo(0, 0)
                }
                this.consultarCartas();
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.hideModal('modalUpload');
            });
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/assinarCartasLote/listarTipoCredito`)
                .then(response => {
                    this.dados.creditos = response.data
                })
        },

        dadosUsuario() {
            let dados = '';
            apiCentralSeguranca.getInformacoesCidadao((JSON.parse(this.$store.getters.getUser).token.access_token))
                .then(res => {
                    dados = res.data;
                    this.cpfUsuarioLogado = dados.cpf
                    this.parametrosAssinatura.filters.CPFS.push(this.cpfUsuarioLogado)
                })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async configurarColunas() {
            this.dados.colunas.forEach((field, i) => {
                this.showColunms.push(i + 1)
                this.fields.push({
                    key: `${i + 1}`,
                    label: `${field}`,
                    sortable: true,
                    sortDirection: "desc",
                    class: this.checkClassTable(i),
                    thClass: '',
                    tdClass: '',
                    codColunaFuncionalidade: i,
                    codFuncionalidade: i
                })
            })
        },
        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
            }
        },

        showModal(id) {
            this.$refs[id].show();
        },

        hideModal(id) {
            this.$refs[id].hide();
        },

        anexarCsv() {
            this.showModal('modalUpload');
        },

    },
    mounted() {
        this.$store.commit("setMessages", {});

        this.dadosUsuario()

        this.configurarColunas()

        this.listarTipoCredito()

        this.consultarCartas()

    }
}
</script>

<style></style>
